export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 4;

  static isAllowed() {
    return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true;
  }

  static addProduct(productId) {
    if (!this.isAllowed()) return;
    let viewedProducts = this.getProducts().filter(id => id !== productId);
    viewedProducts.unshift(productId);
    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts.slice(0, this.#MAX_PRODUCTS)));
    } catch {}
  }

  static clearProducts() {
    try { localStorage.removeItem(this.#STORAGE_KEY); } catch {}
  }

  static getProducts() {
    if (!this.isAllowed()) return [];
    try {
      const products = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      return Array.isArray(products) ? products.filter(id => typeof id === 'string') : [];
    } catch { return []; }
  }
}

const applyPrivacy = () => {
  if (!RecentlyViewed.isAllowed()) RecentlyViewed.clearProducts();
};
document.addEventListener('visitorConsentCollected', applyPrivacy);
if (window.Shopify?.loadFeatures) {
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
    if (!error) applyPrivacy();
  });
}

